import React, { useState, useCallback } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Form,  Label, Button, Row, Col, Spinner } from "reactstrap";
import "./Support.css";
import Uploadform from "../../assets/images/upload_form.svg";
import { useDispatch, useSelector } from "react-redux";
import { createRequest, updateSupportRequest } from "../../api/Applications";
import { handleFileUpload } from "../../utils/ImageToBase64";
import { requestTypeOptions } from "../patient/Constant";
import { failed, success } from "../../utils/Tostify";
import { useNavigate } from "react-router";
import Loader from "../../components/Loader/Loader";
import TextInput from "../../components/InputFields/TextInput";
import { useDropzone } from "react-dropzone";

const CreateRequest = ({ onCancel, getSupportRequestList, isEditMode, editData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userReducer.token);
  const organizationId = localStorage.getItem("currentOrgId");
  const clinicId = localStorage.getItem("currentHospitalId");
  let user = useSelector(state => state.userReducer.user);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    ...(isEditMode ? {} : { title: Yup.string().required("Title is required") }),
    ...(isEditMode ? {} : { description: Yup.string().required("Description is required") }),
    requestType: Yup.string().required("Request Type is required")
  });

  const formik = useFormik({
    initialValues: {
      title: editData?.title || "",
      description: editData?.description || "",
      docFile: null,
      requestType: editData?.requestType || "",
      externalComment: isEditMode ? editData?.externalComment?.commentText || "" : ""
    },
    validationSchema,
    onSubmit: async (values) => {
      let base64Files = [];

      for (let file of selectedFiles) {
        let base64pdfForm = await handleFileUpload(file);
        let fileExtension = file.type.split("/")[1];

        base64Files.push({
          base64String: base64pdfForm,
          extension: fileExtension,
          name: file.name
        });
      }

      let payload = {
        title: values.title,
        description: values.description,
        requestType: values.requestType,
        attachments: base64Files,
        organizationId:organizationId,
        clinicId:clinicId,
        externalComment: isEditMode
          ? values.externalComment
            ? { userId: editData?.externalComment?.userId || user._id, commentText: values.externalComment }
            : undefined
          : undefined
      };

      try {
        setIsLoading(true);
        let res;

        if (isEditMode) {
          res = await updateSupportRequest({values: { ...payload }, dispatch, token, supportId: editData._id });
        } else {
          res = await createRequest({values: { ...payload, createdBy: user._id }, dispatch, token });
        }

        if (res.status === "SUCCESS") {
          success(res?.message);
          if (typeof getSupportRequestList === "function") {
            await getSupportRequestList();
          }
          formik.resetForm();
          setSelectedFiles([]);
          onCancel();
          if (isEditMode) {
            navigate("/app/support/supportDetails", { state: { supportData: editData } });
        } else {
            navigate("/app/support");
        }
        } else {
          failed(res?.message || "Something went wrong");
        }
      } catch (error) {
        failed(error?.message || "Error occurred");
      } finally {
        setIsLoading(false);
      }
    }
  });

  const handleRemoveFile = (index) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updatedFiles);
  };

  const onDrop = useCallback((acceptedFiles) => {
    setSelectedFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/jpeg,image/png,application/pdf",
    multiple: true
  });

  return (
    <div className="create_new_request">
      <h6 className="block_name text-center mt-3">{isEditMode ? "" : "Create New Request"}</h6>
      {isLoading ? <Loader /> : null}
      <Form onSubmit={formik.handleSubmit}>
        <div className="first_block p-3">
          {!isEditMode && (
            <Row>
              <Col lg={6} className="location_block mb-3">
                 <TextInput
                    keyField={"title"}
                    label="Title"
                    required={true}
                    formik={formik}
                    type="text"
                    value={formik.values.title}
                    onChange={(e) => {
                      const inputValue = e.target.value.slice(0, 255); // Limit input to 255 chars
                      formik.setFieldValue("title", inputValue);
                    }}
                  />
              </Col>

              <Col lg={6} className="location_block mb-3">
              <TextInput
                    keyField="requestType"
                    label="Request Type"
                    options={requestTypeOptions}
                    type="select"
                    formik={formik}
                    required={true}
                    placeholder="Select Request Type"
                    value={formik.values.requestType}
                    onChange={(e) => {
                      formik.setFieldValue("requestType", e.target.value);
                    }}
                  />
              </Col>
            </Row>
          )}

          {!isEditMode && (
            <Row>
              <Col lg={12} className="location_block mb-3">
              <p>Description <span style={{color : "red", marginLeft:"3px"}}>*</span></p>
                  <textarea
                    className="form-control"
                    rows="5"  // Controls the height of the box
                    maxLength="500"  // Enforces limit at the browser level
                    value={formik.values.description}
                    onChange={(e) => formik.setFieldValue("description", e.target.value)}
                  />
                  <p>{formik.values.description.length}/500</p> {/* Show character count */}
                   <div>
            {formik?.touched["description"] && formik?.errors["description"] ? (
              <span style={{ color: 'red' }}>{formik?.errors["description"]}</span>
            ) : ""}
          </div>
              </Col>
            </Row>
          )}

          <Row>
            {/* Drag & Drop File Upload */}
            <Label for="externalComment"> Attachment</Label>
              <div {...getRootProps()} className="upload-area text-center">
                <input {...getInputProps()} />
                <img src={Uploadform} alt="upload" />
                <p>Drag & drop files here, or click to browse</p>
                <button type="button" className="browse_blk">Browse</button>
              </div>
          </Row>
          <Row className="mt-3" style={{paddingTop:"0px"}}>
                <Col md={12}>{selectedFiles.length > 0 && (
                      <div className="uploaded-files mt-3">
                        {selectedFiles?.map((file, index) => (
                          <div key={index} className="file-item d-flex justify-content-between align-items-center">
                            <p style={{zIndex:"99"}}>{file.name}</p>
                            <button type="button" className="cancel-btn" onClick={() => handleRemoveFile(index)}>
                              <i className="fas fa-times" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}</Col>
              </Row>
        </div>

        <div className="d-flex gap-3 justify-content-center mb-3">
          <Button type="button" className="save_btn cancel_btn" onClick={onCancel}>Cancel</Button>
          <Button type="submit" className="save_btn" disabled={isLoading}>
            {isLoading ? <Spinner size="sm" /> : "Save"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default CreateRequest;

